'use strict'

export let norwegian_release={
  Overview: {
    fields: {
      summary: {
        help: "Har noen viktige milepæler bare passert, eller er det noen i nær fremtid? Er det noen nylige suksesser eller gjennomslag? Hva er for tiden de viktigste utfordringene? Hva er den generelle helsetilstanden?",
        description: "Beskriv den overordnede status. Anta at leseren ikke har lest den forrige rapporten eller er kjent med detaljene i hva som skal leveres."
      },
      performedAchivements: {
        help: "Hvilket arbeid er utført eller fullført denne perioden? Hvilke epos, brukerhistorier og oppgaver var planlagt å bli ferdig i perioden? Er det noen planlagte oppgaver som ikke ble utført eller fullført i denne perioden? Har det vært utført noen korrigerende tiltak i perioden?",
        description: "Beskriv arbeidet som er utført og målene som er oppnådd i denne perioden"

      },
      plannedAchivements: {
        help: "Hvilket arbeid vil bli gjennomført eller fullført i kommende periode? Hvilke epos, brukerhistorier eller oppgaver er planlagt å bli ferdig i kommende periode? Er det planlagt korrigerende tiltak i den kommende perioden?",
        description: "Beskriv arbeidet og målene som er fastsatt for neste periode"
      },

      benefits: {
        help: "Er vi i rute for å levere den ønskede avkastningen på investeringen? Hvis ikke, hva er forskjellen og hvorfor? Er eventuelle nye gevinster lagt til eller fjernet fra begrunnelsen?",
        description: "Beskriv hvordan arbeidet fører til forventet eller planlagt verdiskapning"
      },
      time: {
        help:"Hva er den siste prognosen for å fullføre denne oppdateringen, og hvordan er det sammenlignet med den kommuniserte langtidsplanen?",
        description: "Beskriv hvordan fremdriften er i forhold til avtalt tidsplanen for denne oppdateringen"
      },
      cost: {
        help:"Hvor mye er brukt til nå på oppdateringen, hva er det forventet å bli brukt totalt og hva er gjeldende godkjenning for utgifter til oppdateringen?",
        description: "Beskriv påløpte kostnader og forholdet til eventuell godkjenning for oppdateringen"
      },

      quality: {
        help:"Har epos, brukerhistorier og oppgaver levert i denne perioden oppfylt de avtalt kvalitetskriteriene? Har akseptmetodene (testing, vurderinger ...) i denne perioden blitt fulgt som avtalt? Har utført arbeid til dags dato i oppdateringen oppfylt de avtalt kvalitetskriteriene?",
        description: "Beskriv hvordan vi oppfyller planlagt funksjonalitet og krav i oppdateringen"
      },
      scope: {
        help:"Var epos, brukerhistorier og oppgaver for denne perioden identifisert og godt definert - inkludert sammensetning og kvalitetskriterier? Er det noen endringer i omfanget for oppdateringen?",
        description: "Beskriv hvordan innholdet i oppdateringen er i forhold til avtalt omfang"
      },

      risk: {
        help:"Hva er det nåværende risikonivået for oppdateringen og hvordan samsvarer det med interessentene risikovillighet? Hva er de viktigste risikoene og hvilke tiltak er utført?",
        description: "Beskriv hvordan dagens risikonivå er sammenlignet med den avtalte risikoappetitten"
      }
    }
  },
};



// WEBPACK FOOTER //
// ./views/progress/labels/norwegian_release.js